import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campaigns, Campus, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { campaigns, consent, consentement, defaultValues, getCampus, salutations, specialities } from "services"
import Formations from "../components/Formations"
import { useState } from "react"

const Form = () => {
  const { recordTypeId, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('ESME-WEBINAR')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      formations: [],
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Apprentissage__c: false,
        Bachelor__c: false,
        CycleInge__c: false,
        Master__c: false,
        Salutation: '',
        Section__c: ''
      },
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  const [optionsAcademicLevels, setOptionsAcademicLevels] = useState([])
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'ESME',
      IONISSchool__c: 'ESME',
      LastForm__c: 'Webinar',
      LeadSource: 'Webinar',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      if (campaignId !== 'unavailable') {
        await submission({
          formId: 'WEBINAR',
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: data.status,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        document.location.href=`${url}?campus=${campus}&campaignId=${campaignId}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('EngineeringSchoolLead')
  // Functions
  const handleAcademicLevels = (academics) => {
    setOptionsAcademicLevels(academics)
  }

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Campus label="Campus souhaité" options={getCampus('ESME_EVENT')} />
        <Campaigns setAcademicLevels={handleAcademicLevels} contact={false} division="ESME" school="ESME" text={`à l'événement virtuel`} textAvailability="pour nos événements virtuels" type="Webinar" />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel academics={optionsAcademicLevels.map(level => level.value)} options={optionsAcademicLevels} school="ESME" section={true} specialites={true} />
        <Formations />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Webinar" school="ESME" />
      </Grid>
    </FormProvider>
  )
}

export default Form
